import { Button, Stack, Typography } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import { PageHeader } from '@/components'

/**
 * A path that matches nothing.
 *
 * It used to render the Resumen silently, which is worse than it sounds: a
 * mistyped or stale link answered a DIFFERENT question than the one it was
 * asked, with no indication that it had, and the address bar kept the wrong
 * path so the reader could not tell what had happened.
 *
 * No provenance legend here: the legend is a key to the four words a panel's
 * chips use, and this page has no panels, no chips and no data.
 */
export default function NotFoundPage() {
  return (
    <Stack spacing={2} sx={{ alignItems: 'flex-start' }}>
      <PageHeader
        title="Esa dirección no existe"
        description="Puede que la pantalla se haya movido, o que el enlace venga truncado. Ninguna de las direcciones anteriores cambió en este rediseño, así que un enlace viejo debería seguir funcionando."
        provenance={null}
      />
      <Typography variant="body2" color="text.secondary">
        Si llegaste desde un enlace compartido, vale la pena copiarlo completo: los filtros y el orden
        de una tabla viajan en la parte de la dirección que va después del signo de interrogación.
      </Typography>
      <Button component={RouterLink} to="/" variant="outlined">
        Ir al resumen
      </Button>
    </Stack>
  )
}
